// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dmt {
  font-family: Lato, sans-serif;
  color: #0f172a;
}

.dmt-sec-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.dmt-sec-title h3 {
  margin: 0;
  font-size: 18.75px;
  font-weight: 600;
  color: #0f172a;
}

.dmt-mission-select {
  position: relative;
  min-width: 238px;
  max-width: min(420px, 100%);
  z-index: 20;
}

.dmt-mission-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100% !important;
  height: 45px;
  min-height: 45px;
  padding: 0 32px 0 14px;
  border: 1px solid #dee4f0;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  color: #0f172a;
  text-align: left;
  font-size: 16.875px;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.dmt-mission-trigger:hover {
  border-color: #c5d0e0;
  background: #fafbfd;
}

.dmt-mission-select.is-open .dmt-mission-trigger {
  border-color: #0d9b87;
  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.14);
}

.dmt-mission-trigger-ic {
  display: none;
}

.dmt-mission-trigger-ic svg {
  width: 15px;
  height: 15px;
}

.dmt-mission-trigger-text {
  min-width: 0;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.dmt-mission-trigger-eyebrow {
  display: none;
}

.dmt-mission-trigger-label {
  font-size: 16.875px;
  font-weight: 500;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.25;
}

.dmt-mission-chevron {
  width: 18px;
  height: 18px;
  flex: none;
  color: #8b99b4;
  display: grid;
  place-items: center;
  transition: transform 0.18s ease, color 0.14s;
}

.dmt-mission-chevron svg {
  width: 14px;
  height: 14px;
}

.dmt-mission-select.is-open .dmt-mission-chevron {
  transform: rotate(180deg);
  color: #0d9b87;
}

.dmt-mission-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  left: 0;
  min-width: 100%;
  background: #fff;
  border: 1px solid #dee4f0;
  border-radius: 12px;
  box-shadow:
    0 12px 32px -12px rgba(15, 23, 42, 0.28),
    0 2px 6px rgba(15, 23, 42, 0.06);
  overflow: hidden;
  animation: dmt-menu-in 0.14s ease-out;
}

@keyframes dmt-menu-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dmt-mission-menu-scroll {
  max-height: 240px;
  overflow-y: auto;
  padding: 6px;
}

.dmt-mission-menu-scroll::-webkit-scrollbar {
  width: 6px;
}

.dmt-mission-menu-scroll::-webkit-scrollbar-thumb {
  background: #c5d0dc;
  border-radius: 99px;
}

.dmt-mission-menu-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.dmt-mission-option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100% !important;
  padding: 10px 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  font-family: Lato, sans-serif;
  text-align: left;
  color: #0f172a;
  transition: background 0.12s;
}

.dmt-mission-option:hover {
  background: #f7f9fd;
}

.dmt-mission-option.is-selected {
  background: #e1f4f0;
}

.dmt-mission-option-dot {
  width: 8px;
  height: 8px;
  border-radius: 99px;
  flex: none;
  background: #c5d0dc;
}

.dmt-mission-option.is-selected .dmt-mission-option-dot {
  background: #0d9b87;
  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.18);
}

.dmt-mission-option-label {
  flex: 1 1;
  min-width: 0;
  font-size: 13.5px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dmt-mission-option.is-selected .dmt-mission-option-label {
  color: #076b5c;
  font-weight: 600;
}

.dmt-mission-check {
  width: 14px;
  height: 14px;
  flex: none;
  color: #0d9b87;
}

.dmt-mission-empty {
  padding: 14px 12px;
  font-size: 13px;
  color: #8b99b4;
  text-align: center;
}

.dmt-prio-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
  align-items: stretch;
}

.dmt-prio-card {
  display: flex;
  flex-direction: column;
  padding: 20px 22.5px;
  background: #fff;
  border: 1px solid #dee4f0;
  border-radius: 12.5px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05), 0 10px 28px -20px rgba(0, 20, 109, 0.4);
  text-align: left;
  cursor: pointer;
  transition: border-color 0.14s, box-shadow 0.14s, transform 0.14s;
  width: 100% !important;
  color: inherit;
  font-size: 0;
  line-height: 0;
}

.dmt-prio-card > * {
  line-height: normal;
}

.dmt-prio-card + .dmt-prio-card {
  margin-top: 20px;
}

.dmt-prio-card:hover {
  border-color: #c5d0e0;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
  transform: translateY(-1px);
}

.dmt-prio-top {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dmt-prio-ic {
  width: 35px;
  height: 35px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  flex: none;
}

.dmt-prio-ic svg {
  width: 17.5px;
  height: 17.5px;
}

.dmt-eyebrow {
  margin: 0;
  font-size: 13.125px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #8b99b4;
}

.dmt-prio-v {
  margin-left: auto;
  font-family: 'IBM Plex Mono', ui-monospace, monospace;
  font-size: 32.5px;
  font-weight: 500;
  letter-spacing: -0.02em;
}

.dmt-bar-track {
  height: 10px;
  border-radius: 99px;
  background: #eaeff7;
  overflow: hidden;
  display: flex;
  margin-top: 17.5px;
}

.dmt-bar-track span {
  height: 100%;
  display: block;
  border-radius: 99px;
}

.dmt-prio-sub {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  margin-top: 12.5px;
  font-size: 15px;
  color: #5b6b87;
}

.dmt-prio-sub b {
  font-family: 'IBM Plex Mono', ui-monospace, monospace;
  font-weight: 500;
  color: #0f172a;
  font-size: 14.375px;
}

.dmt-bottom-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: stretch;
}

.dmt-card {
  background: #fff;
  border: 1px solid #dee4f0;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05), 0 10px 28px -20px rgba(0, 20, 109, 0.4);
  overflow: hidden;
}

.dmt-flexcard {
  display: flex;
  flex-direction: column;
}

.dmt-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 15px 18px;
  border-bottom: 1px solid #eaeff7;
}

.dmt-card-head h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.dmt-hint {
  border: none;
  background: none;
  padding: 0;
  font-size: 15px;
  color: #00146d;
  font-weight: 500;
  cursor: pointer;
  font-family: Lato, sans-serif;
  width: auto !important;
}

.dmt-hint:hover {
  text-decoration: underline;
}

.dmt-card-body {
  padding: 18px;
}

.dmt-flexbody {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.dmt-donut-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 22px;
  flex-wrap: wrap;
}

.dmt-donut {
  width: 150px;
  height: 150px;
  flex: none;
}

.dmt-donut-note {
  font-size: 15px;
  color: #5b6b87;
  max-width: 20ch;
}

.dmt-donut-note b {
  display: block;
  font-family: 'IBM Plex Mono', ui-monospace, monospace;
  font-size: 26px;
  color: #0f172a;
  font-weight: 500;
}

.dmt-legend-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 18px;
  margin-top: 14px;
  justify-content: center;
}

.dmt-legend-row--start {
  justify-content: flex-start;
}

.dmt-legend-row i {
  width: 9px;
  height: 9px;
  border-radius: 3px;
  display: inline-block;
  margin-right: 6px;
  vertical-align: middle;
}

.dmt-legend-row span {
  font-size: 15px;
  color: #5b6b87;
}

.dmt-mono {
  font-family: 'IBM Plex Mono', ui-monospace, monospace;
  font-weight: 500;
  color: #0f172a;
}

.dmt-risk-note {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #eaeff7;
  font-size: 15px;
  color: #5b6b87;
}

.dmt-risk-note svg {
  width: 14px;
  height: 14px;
  flex: none;
  color: #b0730f;
}

.dmt-tp-top {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 14px;
}

.dmt-tp-n {
  font-family: 'IBM Plex Mono', ui-monospace, monospace;
  font-size: 30px;
  font-weight: 500;
  letter-spacing: -0.02em;
}

.dmt-tp-l {
  font-size: 15px;
  color: #5b6b87;
}

.dmt-stack-bar {
  display: flex;
  height: 12px;
  border-radius: 99px;
  overflow: hidden;
  background: #eaeff7;
}

.dmt-stack-bar span {
  display: block;
  height: 100%;
}

.dmt-mini-list {
  display: grid;
  gap: 10px;
  margin-top: auto;
  padding-top: 16px;
}

.dmt-mini-row {
  display: flex;
  align-items: center;
  gap: 11px;
  font-size: 16px;
}

.dmt-mini-row .dmt-bar-track {
  flex: 1 1;
  margin-top: 0;
}

.dmt-mini-k {
  width: 160px;
  color: #5b6b87;
  font-size: 16px;
  flex: none;
}

.dmt-mini-v {
  font-family: 'IBM Plex Mono', ui-monospace, monospace;
  font-size: 16px;
  width: 38px;
  text-align: right;
  flex: none;
}

@media (max-width: 1100px) {
  .dmt-prio-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 900px) {
  .dmt-bottom-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 560px) {
  .dmt-prio-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/mission/components/DashboardMissionsTab.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB;;oCAEkC;EAClC,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,qFAAqF;EACrF,gBAAgB;EAChB,eAAe;EACf,iEAAiE;EACjE,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qDAAqD;EACrD,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qFAAqF;EACrF,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qDAAqD;EACrD,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,qDAAqD;EACrD,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".dmt {\n  font-family: Lato, sans-serif;\n  color: #0f172a;\n}\n\n.dmt-sec-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n\n.dmt-sec-title h3 {\n  margin: 0;\n  font-size: 18.75px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.dmt-mission-select {\n  position: relative;\n  min-width: 238px;\n  max-width: min(420px, 100%);\n  z-index: 20;\n}\n\n.dmt-mission-trigger {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100% !important;\n  height: 45px;\n  min-height: 45px;\n  padding: 0 32px 0 14px;\n  border: 1px solid #dee4f0;\n  border-radius: 8px;\n  background: #fff;\n  cursor: pointer;\n  color: #0f172a;\n  text-align: left;\n  font-size: 16.875px;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.dmt-mission-trigger:hover {\n  border-color: #c5d0e0;\n  background: #fafbfd;\n}\n\n.dmt-mission-select.is-open .dmt-mission-trigger {\n  border-color: #0d9b87;\n  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.14);\n}\n\n.dmt-mission-trigger-ic {\n  display: none;\n}\n\n.dmt-mission-trigger-ic svg {\n  width: 15px;\n  height: 15px;\n}\n\n.dmt-mission-trigger-text {\n  min-width: 0;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.dmt-mission-trigger-eyebrow {\n  display: none;\n}\n\n.dmt-mission-trigger-label {\n  font-size: 16.875px;\n  font-weight: 500;\n  color: #0f172a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.25;\n}\n\n.dmt-mission-chevron {\n  width: 18px;\n  height: 18px;\n  flex: none;\n  color: #8b99b4;\n  display: grid;\n  place-items: center;\n  transition: transform 0.18s ease, color 0.14s;\n}\n\n.dmt-mission-chevron svg {\n  width: 14px;\n  height: 14px;\n}\n\n.dmt-mission-select.is-open .dmt-mission-chevron {\n  transform: rotate(180deg);\n  color: #0d9b87;\n}\n\n.dmt-mission-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  left: 0;\n  min-width: 100%;\n  background: #fff;\n  border: 1px solid #dee4f0;\n  border-radius: 12px;\n  box-shadow:\n    0 12px 32px -12px rgba(15, 23, 42, 0.28),\n    0 2px 6px rgba(15, 23, 42, 0.06);\n  overflow: hidden;\n  animation: dmt-menu-in 0.14s ease-out;\n}\n\n@keyframes dmt-menu-in {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.dmt-mission-menu-scroll {\n  max-height: 240px;\n  overflow-y: auto;\n  padding: 6px;\n}\n\n.dmt-mission-menu-scroll::-webkit-scrollbar {\n  width: 6px;\n}\n\n.dmt-mission-menu-scroll::-webkit-scrollbar-thumb {\n  background: #c5d0dc;\n  border-radius: 99px;\n}\n\n.dmt-mission-menu-scroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.dmt-mission-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100% !important;\n  padding: 10px 12px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n  font-family: Lato, sans-serif;\n  text-align: left;\n  color: #0f172a;\n  transition: background 0.12s;\n}\n\n.dmt-mission-option:hover {\n  background: #f7f9fd;\n}\n\n.dmt-mission-option.is-selected {\n  background: #e1f4f0;\n}\n\n.dmt-mission-option-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 99px;\n  flex: none;\n  background: #c5d0dc;\n}\n\n.dmt-mission-option.is-selected .dmt-mission-option-dot {\n  background: #0d9b87;\n  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.18);\n}\n\n.dmt-mission-option-label {\n  flex: 1;\n  min-width: 0;\n  font-size: 13.5px;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dmt-mission-option.is-selected .dmt-mission-option-label {\n  color: #076b5c;\n  font-weight: 600;\n}\n\n.dmt-mission-check {\n  width: 14px;\n  height: 14px;\n  flex: none;\n  color: #0d9b87;\n}\n\n.dmt-mission-empty {\n  padding: 14px 12px;\n  font-size: 13px;\n  color: #8b99b4;\n  text-align: center;\n}\n\n.dmt-prio-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin-bottom: 24px;\n  align-items: stretch;\n}\n\n.dmt-prio-card {\n  display: flex;\n  flex-direction: column;\n  padding: 20px 22.5px;\n  background: #fff;\n  border: 1px solid #dee4f0;\n  border-radius: 12.5px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05), 0 10px 28px -20px rgba(0, 20, 109, 0.4);\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.14s, box-shadow 0.14s, transform 0.14s;\n  width: 100% !important;\n  color: inherit;\n  font-size: 0;\n  line-height: 0;\n}\n\n.dmt-prio-card > * {\n  line-height: normal;\n}\n\n.dmt-prio-card + .dmt-prio-card {\n  margin-top: 20px;\n}\n\n.dmt-prio-card:hover {\n  border-color: #c5d0e0;\n  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);\n  transform: translateY(-1px);\n}\n\n.dmt-prio-top {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.dmt-prio-ic {\n  width: 35px;\n  height: 35px;\n  border-radius: 10px;\n  display: grid;\n  place-items: center;\n  flex: none;\n}\n\n.dmt-prio-ic svg {\n  width: 17.5px;\n  height: 17.5px;\n}\n\n.dmt-eyebrow {\n  margin: 0;\n  font-size: 13.125px;\n  font-weight: 600;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #8b99b4;\n}\n\n.dmt-prio-v {\n  margin-left: auto;\n  font-family: 'IBM Plex Mono', ui-monospace, monospace;\n  font-size: 32.5px;\n  font-weight: 500;\n  letter-spacing: -0.02em;\n}\n\n.dmt-bar-track {\n  height: 10px;\n  border-radius: 99px;\n  background: #eaeff7;\n  overflow: hidden;\n  display: flex;\n  margin-top: 17.5px;\n}\n\n.dmt-bar-track span {\n  height: 100%;\n  display: block;\n  border-radius: 99px;\n}\n\n.dmt-prio-sub {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 12.5px;\n  font-size: 15px;\n  color: #5b6b87;\n}\n\n.dmt-prio-sub b {\n  font-family: 'IBM Plex Mono', ui-monospace, monospace;\n  font-weight: 500;\n  color: #0f172a;\n  font-size: 14.375px;\n}\n\n.dmt-bottom-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  align-items: stretch;\n}\n\n.dmt-card {\n  background: #fff;\n  border: 1px solid #dee4f0;\n  border-radius: 10px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05), 0 10px 28px -20px rgba(0, 20, 109, 0.4);\n  overflow: hidden;\n}\n\n.dmt-flexcard {\n  display: flex;\n  flex-direction: column;\n}\n\n.dmt-card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 15px 18px;\n  border-bottom: 1px solid #eaeff7;\n}\n\n.dmt-card-head h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.dmt-hint {\n  border: none;\n  background: none;\n  padding: 0;\n  font-size: 15px;\n  color: #00146d;\n  font-weight: 500;\n  cursor: pointer;\n  font-family: Lato, sans-serif;\n  width: auto !important;\n}\n\n.dmt-hint:hover {\n  text-decoration: underline;\n}\n\n.dmt-card-body {\n  padding: 18px;\n}\n\n.dmt-flexbody {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.dmt-donut-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 22px;\n  flex-wrap: wrap;\n}\n\n.dmt-donut {\n  width: 150px;\n  height: 150px;\n  flex: none;\n}\n\n.dmt-donut-note {\n  font-size: 15px;\n  color: #5b6b87;\n  max-width: 20ch;\n}\n\n.dmt-donut-note b {\n  display: block;\n  font-family: 'IBM Plex Mono', ui-monospace, monospace;\n  font-size: 26px;\n  color: #0f172a;\n  font-weight: 500;\n}\n\n.dmt-legend-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 18px;\n  margin-top: 14px;\n  justify-content: center;\n}\n\n.dmt-legend-row--start {\n  justify-content: flex-start;\n}\n\n.dmt-legend-row i {\n  width: 9px;\n  height: 9px;\n  border-radius: 3px;\n  display: inline-block;\n  margin-right: 6px;\n  vertical-align: middle;\n}\n\n.dmt-legend-row span {\n  font-size: 15px;\n  color: #5b6b87;\n}\n\n.dmt-mono {\n  font-family: 'IBM Plex Mono', ui-monospace, monospace;\n  font-weight: 500;\n  color: #0f172a;\n}\n\n.dmt-risk-note {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid #eaeff7;\n  font-size: 15px;\n  color: #5b6b87;\n}\n\n.dmt-risk-note svg {\n  width: 14px;\n  height: 14px;\n  flex: none;\n  color: #b0730f;\n}\n\n.dmt-tp-top {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.dmt-tp-n {\n  font-family: 'IBM Plex Mono', ui-monospace, monospace;\n  font-size: 30px;\n  font-weight: 500;\n  letter-spacing: -0.02em;\n}\n\n.dmt-tp-l {\n  font-size: 15px;\n  color: #5b6b87;\n}\n\n.dmt-stack-bar {\n  display: flex;\n  height: 12px;\n  border-radius: 99px;\n  overflow: hidden;\n  background: #eaeff7;\n}\n\n.dmt-stack-bar span {\n  display: block;\n  height: 100%;\n}\n\n.dmt-mini-list {\n  display: grid;\n  gap: 10px;\n  margin-top: auto;\n  padding-top: 16px;\n}\n\n.dmt-mini-row {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  font-size: 16px;\n}\n\n.dmt-mini-row .dmt-bar-track {\n  flex: 1;\n  margin-top: 0;\n}\n\n.dmt-mini-k {\n  width: 160px;\n  color: #5b6b87;\n  font-size: 16px;\n  flex: none;\n}\n\n.dmt-mini-v {\n  font-family: 'IBM Plex Mono', ui-monospace, monospace;\n  font-size: 16px;\n  width: 38px;\n  text-align: right;\n  flex: none;\n}\n\n@media (max-width: 1100px) {\n  .dmt-prio-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 900px) {\n  .dmt-bottom-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 560px) {\n  .dmt-prio-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
